module.exports = __webpack_public_path__ + "static/bamboo-fdbd71d72e9a8bb8391dfeada421a5cf.svg";